import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    setTimeout(() => {
      window.scrollTo(0, 0);
      document.documentElement.scrollTop = 0; // For modern browsers
      document.body.scrollTop = 0; // For Safari & older browsers
    }, 0); // Run instantly

  }, [pathname]);

  return null;
};

export default ScrollToTop;
